import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-81" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-2xl rounded-xl border-2 border-brand-cta/40 bg-white p-4 text-center sm:p-6" data-id="element-82" data-mp="1o5q1qgnuw7zz">
        <ShieldCheckIcon className="mx-auto h-9 w-9 text-brand-cta" aria-hidden="true" data-id="element-83" data-mp="22126zhzn1gv5" />
        <h2 className="mt-2 font-serif text-2xl font-bold uppercase leading-tight text-brand-brown sm:text-3xl" data-id="element-84" data-mp="19ehfmhj5x4rl">
          Votre achat est protégé à 100 %
        </h2>
        <p className="mt-2 text-[13px] font-semibold leading-snug text-brand-brown sm:text-[15px]" data-id="element-85" data-mp="14dl35fkqwaak">
          Explorez YIN YOGA PRO™ pendant 7 jours.
        </p>
        <p className="mt-1.5 text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-sm" data-id="element-86" data-mp="1ecsooq1mvb8r">
          Découvrez les six modules, les postures visuelles, les séquences, les
          adaptations, les ressources de planification et les quatre bonus
          professionnels.
        </p>
        <p className="mt-1.5 text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-sm" data-id="element-87" data-mp="oygmyiq27kce">
          Si le système ne vous convient pas, contactez-nous dans les 7 jours
          pour obtenir un remboursement intégral conformément aux conditions de
          remboursement.
        </p>
      </div>
    </section>;
}